'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveUnifiedThreadHistory = exports.resolveUnifiedThreadHistory = function resolveUnifiedThreadHistory() {
  return import( /* webpackChunkName: "unified-thread-view" */'../../thread-view/components/UnifiedThreadView');
};